import {FormattedMessage} from "react-intl";
import React from "react";

export default ({id, value}) => {
    return <FormattedMessage id={id || 'None'}>{text => <option value={value}>{text}</option>}</FormattedMessage>
}
